var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.auth('PROVIDER'))?_c('provider-account'):(_vm.auth('ORG'))?_c('org-account'):(_vm.auth('SCHOOL', 'ORG_SCHOOL'))?_c('school-account'):(_vm.auth('ADMIN'))?_c('all-account'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }